//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Button, Input, Row, Space } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { useRequireApprovePoint } from "hooks/usePoint";
import { FC, useState } from "react";
import PointTableList from "./PointTableList";

interface RequireApproveProps {}

const RequireApprove: FC<RequireApproveProps> = () => {
  const dispatch = useAppDispatch();
  const constact = useAppSelector((state) => state.auth.contact);

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchInput, setSearchInput] = useState("");

  const { data: dataRequireApprovePoint } = useRequireApprovePoint({
    search: searchInput,
    offset: offset,
    limit: limit,
    factory_id: constact?.id || "",
  });

  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          <ButtonWrapper>
            <Space.Compact>
              <Input
                style={{ height: "32px", width: "100px;" }}
                placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <Button type="default">ค้นหา</Button>
            </Space.Compact>
          </ButtonWrapper>
          {/* <PaginationWrapper
          current={currentPage}
          size={'small'}
          responsive={true}
          // totalBoundaryShowSizeChanger={3}
          onChange={(page) => setCurrentPage(page)}
          // total={data?.contacts?.length || 0}
          total={data?.data?.total_record}
          // defaultCurrent={3} 
          pageSize={itemsPerPage}
          // showSizeChanger={true}
        /> */}
          {/* <Button type="default" onClick={handleButtonClick}>
          {isTable ? "แสดงแบบ Cards" : "แสดงแบบ Table"}
        </Button> */}
        </HeadWrapper>
        <Row
          gutter={[16, 16]}
          style={{ overflow: "auto", backgroundColor: "#EFEFEF" }}
        >
          <CardWrapperTable>
            <PointTableList
              data={dataRequireApprovePoint?.data}
              offset={offset}
              limit={limit}
              setOffset={setOffset}
              setLimit={setLimit}
            />
          </CardWrapperTable>
        </Row>
      </WrapperAll>
    </>
  );
};

export default RequireApprove;

// const PaginationWrapper = styled(Pagination)`
//   white-space: nowrap;
// `;
const WrapperAll = styled.div`
  padding: 10px 10px 10px 8px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
